import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom'
import { ThemeProvider } from './context/ThemeContext'
import SiteShell from './components/SiteShell'
import SceneHub from './components/SceneHub'
import SceneHubLeaf from './components/SceneHubLeaf'
import About from './pages/About'
import ProjectDetail from './pages/ProjectDetail'

const LegacyProjectRedirect = () => {
  const { projectId } = useParams()
  return <Navigate to={`/projects/${projectId}`} replace />
}

const App = () => {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<SiteShell />}>
            {/* One SceneHub parent keeps the 3D scene mounted across these URLs */}
            <Route element={<SceneHub />}>
              <Route index element={<SceneHubLeaf />} />
              <Route path="contact" element={<SceneHubLeaf />} />
              <Route path="projects/:projectId" element={<SceneHubLeaf />} />
              <Route path="projects/:projectId/details" element={<ProjectDetail />} />
              <Route path="about" element={<About />} />
              <Route path="work" element={<Navigate to="/" replace />} />
              <Route path="work/:projectId" element={<LegacyProjectRedirect />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  )
}

export default App
